import { render, staticRenderFns } from "./FilmTypeModal.vue?vue&type=template&id=22aad582&scoped=true&"
import script from "./FilmTypeModal.vue?vue&type=script&lang=js&"
export * from "./FilmTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./FilmTypeModal.vue?vue&type=style&index=0&id=22aad582&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aad582",
  null
  
)

export default component.exports